// extracted by mini-css-extract-plugin
module.exports = {"FallbackContainer":"SuspenseFallback_FallbackContainer__x-4N7"};